export const NO_SELECTION_VALUE = 'none';
